import createInfiniteQueryHook from '@segment/utils/createInfinityQueryHook';
import { useCatalogAlphaIndex, useCatalogSearchIndex } from '@segment/contexts/catalogIndex';
import { fetchIntegrations } from './common';
export var createIntegrationsQuery = function createIntegrationsQuery(_ref, _ref2) {
  var catalogIndex = _ref.catalogIndex,
      catalogSearchIndex = _ref.catalogSearchIndex;
  var query = _ref2.query,
      _ref2$category = _ref2.category,
      category = _ref2$category === void 0 ? null : _ref2$category,
      _ref2$destination = _ref2.destination,
      destination = _ref2$destination === void 0 ? true : _ref2$destination,
      _ref2$source = _ref2.source,
      source = _ref2$source === void 0 ? true : _ref2$source,
      _ref2$categoryNegatio = _ref2.categoryNegation,
      categoryNegation = _ref2$categoryNegatio === void 0 ? false : _ref2$categoryNegatio,
      _ref2$hitsPerPage = _ref2.hitsPerPage,
      hitsPerPage = _ref2$hitsPerPage === void 0 ? 20 : _ref2$hitsPerPage,
      filters = _ref2.filters;
  return [["catalog", "integrationsQuery", query, category, destination, source, categoryNegation, hitsPerPage], function (_ref3) {
    var pageParam = _ref3.pageParam;
    return fetchIntegrations({
      query: query,
      catalogIndex: query === "" ? catalogIndex : catalogSearchIndex,
      category: category,
      destination: destination,
      pageParam: pageParam,
      source: source,
      categoryNegation: categoryNegation,
      hitsPerPage: hitsPerPage,
      filters: filters
    });
  }];
};
export var useIntegrationsQuery = createInfiniteQueryHook(createIntegrationsQuery, function () {
  var catalogIndex = useCatalogAlphaIndex();
  var catalogSearchIndex = useCatalogSearchIndex();
  return {
    catalogIndex: catalogIndex,
    catalogSearchIndex: catalogSearchIndex
  };
}, {
  staleTime: Infinity,
  getPreviousPageParam: function getPreviousPageParam(p) {
    var _p$page;

    var page = (_p$page = p.page) !== null && _p$page !== void 0 ? _p$page : 0;
    var prevPage = page - 1;

    if (prevPage < 0) {
      return;
    }

    return prevPage;
  },
  getNextPageParam: function getNextPageParam(p) {
    var _p$page2;

    var page = (_p$page2 = p.page) !== null && _p$page2 !== void 0 ? _p$page2 : 0;
    var nextPage = page + 1;

    if (nextPage >= p.nbPages) {
      return;
    }

    return nextPage;
  }
});